import * as React from "react";
import { ParceiroParametroDetalhe } from "./detalhe";
import { ParceiroParametroBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const ParametroParceiroPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.partnerParameters.titlePage"));

  return (
    <React.Fragment>
      <ParceiroParametroDetalhe />
      <ParceiroParametroBottom />
    </React.Fragment>
  );
};
